var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteFeaturedProducts = function SvgGradientWhiteFeaturedProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.144.972C4.82.537 6.868 2.018 7.814 2.884a.3.3 0 0 1 .096.218l.078 5.742a.306.306 0 0 1-.306.31H1.185a.306.306 0 0 1-.306-.306V1.272c0-.152.113-.282.265-.3Z",
    fill: "url(#gradient-white-featured-products_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.534.972C10.816.537 8.747 2.018 7.791 2.884a.3.3 0 0 0-.098.219l-.079 5.74c-.002.172.136.311.306.311h6.574a.306.306 0 0 0 .306-.306V1.273a.302.302 0 0 0-.266-.3Z",
    fill: "url(#gradient-white-featured-products_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.504 1.823c3.363-.718 6.2.332 7.351 1.033a.292.292 0 0 1 .137.252v7.882a.076.076 0 0 1-.076.076H.574a.306.306 0 0 1-.306-.306V2.118c0-.142.098-.266.236-.295Zm5.144 3.349c-1.393-.363-2.862-.3-3.407-.224a.352.352 0 1 1-.097-.696c.61-.085 2.177-.152 3.681.24a.352.352 0 0 1-.177.68Zm-2.852 1.04c.528-.073 1.507-.03 2.31.197a.352.352 0 1 0 .192-.676c-.894-.253-1.97-.304-2.599-.217a.352.352 0 0 0 .097.696Z",
    fill: "url(#gradient-white-featured-products_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.129 2.79c1.15-.707 3.988-1.766 7.352-1.042a.3.3 0 0 1 .236.295v8.717a.306.306 0 0 1-.306.306H8.07a.076.076 0 0 1-.077-.077V3.041c0-.102.05-.197.137-.25Zm6.364 6.861a.497.497 0 1 1-.994 0 .497.497 0 0 1 .994 0Z",
    fill: "url(#gradient-white-featured-products_svg__d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-featured-products_svg__a",
    x1: 4.92,
    y1: 0.126,
    x2: 4.206,
    y2: 3.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-featured-products_svg__b",
    x1: 10.631,
    y1: -0.052,
    x2: 10.993,
    y2: 3.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-featured-products_svg__c",
    x1: 4.691,
    y1: 0.391,
    x2: 4.516,
    y2: 18.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-featured-products_svg__d",
    x1: 7.419,
    y1: 1.732,
    x2: 19.197,
    y2: 19.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
};

export default SvgGradientWhiteFeaturedProducts;